import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import Button from '../../../../../../../../Form/Button';
import RemoveParticipantStore from '../RemoveParticipantStore/Store';
import { Ready } from '../RemoveParticipantStore/Types';

export interface Props {
  store: RemoveParticipantStore;
  state: Ready;
}

function SuccessfullyWarned({ store, state }: Props) {
  return (
    <div className="flex justify-center mt-20">
      <div className="flex flex-col items-center">
        <div>
          <T
            kind="Participant {{participantName}} will be removed from {{groupName}}. Do you want to continue?"
            participantName={state.participant.payload.fullName.getOrElseValue('')}
            groupName={state.groupResource.payload.name}
          />
        </div>
        <div className="flex w-2/3">
          <Button
            className={clsx(
              'rounded-md cursor-pointer text-teal-600 bg-white border border-teal-600 py-3',
              ' text-sm w-1/3 text-center mt-10 mb-4 mx-auto',
            )}
            value="Yes"
            type="button"
            onClick={() => store.deleting(state.participant, state.groupResource)}
          />
          <Button
            className={clsx(
              'rounded-md cursor-pointer bg-teal-600 text-white py-3 text-sm w-1/3',
              'text-center mt-10 mb-4 mx-auto',
            )}
            value="No"
            type="button"
            onClick={store.closeModal}
          />
        </div>
      </div>
    </div>
  );
}

export default observer(SuccessfullyWarned);
